import { render, staticRenderFns } from "./productArea.vue?vue&type=template&id=f6f70fd0&scoped=true&"
import script from "./productArea.vue?vue&type=script&lang=js&"
export * from "./productArea.vue?vue&type=script&lang=js&"
import style0 from "./productArea.vue?vue&type=style&index=0&id=f6f70fd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f70fd0",
  null
  
)

export default component.exports